export default "__VITE_ASSET__DMwIe3Vb__"